import "./style.less";

export default function PeriodsNoResults(houseService) {
    return {
        restrict: "E",
        scope: {
            items: "=",
        },
        template: require("./template.html"),
        controller: function (
            $scope,
            $rootScope,
            $filter,
            searchBarFactory,
            moment,
            searchResultFactory
        ) {
            $scope.periodsWithinSelectedTime =
                searchResultFactory.periodsWithinSelectedTime;

            $scope.searchFilter = houseService.searchFilter;

            /**************************************
             * NO RESULTS
             **************************************/

            $scope.getNextAvailableResults = function () {
                houseService
                    .getSearchGroupedNextResult()
                    .then(function (houses) {
                        if (
                            houses.GroupingInfos.length ||
                            houses.ParentLanes.length
                        ) {
                            // Convert API date
                            var nextAvailableDate = $filter("date")(
                                houses.NextAvailableDate,
                                "dd-MM-yyyy"
                            );

                            // Set neccesary date vars
                            houseService.searchFilter.startDate =
                                nextAvailableDate;

                            houseService.searchFilter.startTime = angular.copy(
                                houseService.calenderFilter.startTime()
                            ); // update the API param

                            houseService.calenderFilter.selectedDate =
                                nextAvailableDate;

                            $scope.oSearchCalender =
                                searchBarFactory.get_oSearchCalender();
                            $scope.oSearchCalender.userSelected.date =
                                nextAvailableDate; // will bind to (houseService.searchFilter.startDate) when clicking search in search Bar

                            $rootScope.$broadcast("update-date-broadcast", {
                                date: nextAvailableDate,
                                tooltip: true,
                            });

                            // Format startDate
                            houseService.searchFilter.startDateDayOfWeek =
                                moment(
                                    houseService.searchFilter.startDate,
                                    "DD-MM-YYYY"
                                ).toDate();

                            $rootScope.$broadcast(
                                "next-results-update-broadcast",
                                houses
                            );

                            searchBarFactory.searchBroadcast();
                        } else {
                            // NO RESULT IN RANGE
                            $scope.searchResults = houseService.searchResults =
                                houses;
                        }
                    });
            };
        },
    };
}
